import { render, staticRenderFns } from "./farming.vue?vue&type=template&id=0b1f0376&scoped=true"
import script from "./farming.vue?vue&type=script&lang=js"
export * from "./farming.vue?vue&type=script&lang=js"
import style0 from "./farming.vue?vue&type=style&index=0&id=0b1f0376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f0376",
  null
  
)

export default component.exports